<!-- 注册页 -->

<template>
  <div class="flex registerConBox">
    <!-- 左侧菜单 -->

    <leftMenu />

    <div class="flex cogBgBox fdcolmun jcenter" style="height: 100%;">
      <!-- 内容 -->

      <div class="regfisterRightConBox">
        <el-carousel
          ref="registerBodyCarouselRef"
          height="904px"
          :autoplay="false"
          :interval="0"
          arrow="never"
          :loop="false"
          class="registerBodyCarousel"
          indicator-position="outside"
          v-if="ops.step != 4"
        >
          <el-carousel-item>
            <!-- 个人详细信息 step1 -->

            <personalDetails ref="PersonalDetails" />
          </el-carousel-item>

          <el-carousel-item>
            <!-- 校验 step2 -->

            <ocheck ref="Ocheck" />
          </el-carousel-item>

          <el-carousel-item>
            <!-- 验证码 step3 -->

            <div>
              <verificationCode ref="VerificationCode" />
            </div>
          </el-carousel-item>
        </el-carousel>

        <!-- 防止跳转页面时出现滚动动画放到单独的el-carousel里 -->

        <el-carousel
          ref="registerBodyCarouselRef"
          height="800px"
          :autoplay="false"
          :interval="0"
          arrow="never"
          :loop="false"
          class="registerBodyCarousel"
          indicator-position="outside"
          v-else
        >
          <el-carousel-item>
            <!-- 欢迎视频 step4 -->

            <welcomeVideo ref="WelcomeVideo" />
          </el-carousel-item>
        </el-carousel>

        <div class="stepIconList dip">
          <div
            class="stepBox"
            v-for="item in 3"
            :key="item"
            :class="{
              active: ops.step == item || (item == 3 && ops.step >= 3),
            }"
          ></div>
        </div>
      </div>
    </div>

    <div class="rakuYear">
      © Rakumart 2026
    </div>
  </div>
</template>

<script>
import ops from "./utils/opStore.js";

import leftMenu from "./components/model-leftMenu.vue";

import personalDetails from "./components/model-personalDetails.vue";

import ocheck from "./components/model-ocheck.vue";

import verificationCode from "./components/model-verificationCode.vue";

import welcomeVideo from "./components/model-welcomeVideo.vue";

export default {
  data() {
    return { ops };
  },

  components: {
    leftMenu,

    personalDetails,

    ocheck,

    verificationCode,

    welcomeVideo,
  },

  watch: {
    "ops.step"(newv, oldv) {
      console.log(newv, oldv, this.ops.step);

      if (this.ops.step < 4 && this.$refs.registerBodyCarouselRef) {
        this.$refs.registerBodyCarouselRef.setActiveItem(this.ops.step - 1);
      }
    },
  },

  computed: {},

  created() {
    if (this.$route.query.email) {
      this.ops.formregister.email = this.$route.query.email;
    }

    if (this.$route.name == "register-success") {
      this.ops.step = 4;
    }
  },

  mounted() {
    this.ops.PersonalDetails = this.$refs.PersonalDetails;

    this.ops.Ocheck = this.$refs.Ocheck;

    this.ops.VerificationCode = this.$refs.VerificationCode;

    this.ops.WelcomeVideo = this.$refs.WelcomeVideo;

    this.ops.registerBodyCarouselRef = this.$refs.registerBodyCarouselRef;

    this.$nextTick(() => {
      if (this.ops.step < 4 && this.$refs.registerBodyCarouselRef) {
        this.$refs.registerBodyCarouselRef.setActiveItem(this.ops.step - 1);
      }
    });
  },

  methods: {},
};
</script>

<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

.registerConBox {
  height: 100vh;

  min-height: 100%;

  overflow: auto;

  background-color: white;

  position: relative;

  .cogBgBox {
    flex: 1;

    height: 100%;

    background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512134339452999.png");

    background-repeat: no-repeat;

    background-position: center 150px;

    background-size: 3000px;

    background-color: white;
  }

  .regfisterRightConBox {
  }

  .rakuYear {
    position: absolute;

    right: 100px;

    bottom: 42px;
  }
}

.registerBodyCarousel {
  /deep/.el-carousel__indicators {
    display: none;
  }

  /deep/.el-carousel__item {
    display: flex;

    align-items: center;

    justify-content: center;
  }
}

.stepIconList {
  gap: 12px;

  .stepBox {
    width: 30px;

    height: 8px;

    border-radius: 4px;

    background: var(--Gray-200, #eaecf0);
  }

  .active {
    background: var(--Gray-200, #009246);
  }
}
</style>
